import React, {Component} from 'react';
import LocalDate from '../LocalDate'
import {normalizzaAttivitaGiorno} from '../../Helpers'
import PropTypes from 'prop-types';
class AttivitaRiepilogoOrarioCircolare extends Component {

    constructor(props) {
        super(props);
        this.state = {
            width: 500,
            height: 500,
        };
        this.writeChart = this.writeChart.bind(this);
        this.prevAttivitaComplete = undefined;
        this.updateCount = -1;
    }

    componentDidMount() {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions.bind(this));

        this.writeChart();
        this.prevAttivitaComplete = this.props.attivitaComplete;
        if (this.props.onChartUpdated !== undefined){
            let img = this.refs.chart.toDataURL();
            this.props.onChartUpdated(img);
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }

    componentDidUpdate() {
        this.writeChart();
        if (this.prevAttivitaComplete !== this.props.attivitaComplete){
            this.updateCount = 1;
        }
        else
        {
            this.updateCount--;
        }
        this.prevAttivitaComplete = this.props.attivitaComplete;
        if (this.props.onChartUpdated !== undefined && this.updateCount >= 0){
            let img = this.refs.chart.toDataURL();
            this.props.onChartUpdated(img);
        }
    }

    updateDimensions() {

        if (this.refs.chartContainer)
        {
            let winWidth = this.refs.chartContainer.offsetWidth;
            //let winHeight = this.refs.chartContainer.offsetWidth;

            if(winWidth < 50) {
                this.setState({ width: 50, height: 50 });
            } else {
                let update_width  = winWidth;
                let update_height = update_width;
                this.setState({ width: update_width, height: update_height });
            }
        }
    }

    scaleTimes(time){
        return Math.round((time*this.barCanvasWidth)/1440);
    }

    writeChart(){


        let center_x = this.state.width / 2;
        let center_y = this.state.height / 2;
        let radius = (this.state.width/2) * 0.8;
        let hBanda = radius / this.props.maxSovrapposizioni;


        let numRighe = 1;

        let LC = undefined;
        let attList = this.props.attivitaComplete;
        if (attList !== undefined) {
            LC = normalizzaAttivitaGiorno(attList);
            numRighe = LC.length;
        }

        /*
        Inizializzazione
         */
        let canvas = this.refs.chart;
        if (!canvas.getContext) return;
        var ctx = canvas.getContext('2d');

        ctx.clearRect(0, 0, this.state.width, this.state.height);
        ctx.save();
        ctx.translate(center_x, center_y);
        ctx.rotate(-Math.PI / 2);
        ctx.clearRect(radius*(-1), radius*(-1), radius, radius);

        center_x = 0;
        center_y = 0;



        if (LC !== undefined) {

            /*
             Disegno delle barre per le attività
             */

            for (let i=0; i<numRighe; i++){
                LC[i].forEach((att) => {

                    if (att.durata !== 0){
                        let i1 = (att.inizio*2*Math.PI)/1440;
                        let i2 = (att.fine*2*Math.PI)/1440;
                        ctx.lineWidth = hBanda;
                        if (att.idCommessa !== undefined){
                            ctx.fillStyle = att.idCommessa.colore;
                            ctx.strokeStyle = att.idCommessa.colore;
                        }
                        else
                        {
                            ctx.fillStyle = 'rgba(238,238,238,0.7)';
                            ctx.strokeStyle = 'rgba(238,238,238,0.7)';
                        }

                        ctx.beginPath();
                        ctx.arc(center_x, center_y, radius-(i*(hBanda+4) + 4), i1, i2);
                        ctx.stroke();
                    }

                })
            }

        }



        /*
        Disegna l'esterno dell'orologio
         */
        let extRadius = radius + hBanda/2 ;
        ctx.strokeStyle = 'black';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.arc(center_x, center_y, extRadius, 0, 2 * Math.PI);
        ctx.stroke();

        ctx.save();
        ctx.strokeStyle = 'black';
        ctx.fillStyle = 'white';
        ctx.lineWidth = 1;
        ctx.lineCap = 'round';
        let oursRadius = (this.state.width/2);
        for (var i = 0; i < 24; i++) {
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';
            let fontSize = (1).toFixed(2);
            ctx.font = fontSize + "em sans-serif";

            ctx.beginPath();
            ctx.moveTo(extRadius-((numRighe)*(hBanda+4)), 0);
            ctx.lineTo(oursRadius, 0);
            ctx.strokeStyle = 'black';
            ctx.strokeText(''+i, oursRadius + (extRadius - oursRadius)/2, 0);
            ctx.rotate(Math.PI / 12);
            ctx.strokeStyle = '#AAAAAA';
            ctx.stroke();

        }
        ctx.restore();

        ctx.restore();

        /*
         Scrive il messaggio
         */
        if (this.props.message){
            ctx.save();

            ctx.translate(this.state.width/2, this.state.height/2);

            let text1 = '';
            let text2 = '';
            let hText = 13;

            let lines = this.props.message.split(':');
            if (lines.length > 0){
                text1 = lines[0];
            }
            if (lines.length > 1){
                text2 = lines[1];
            }

            let fontSize = (this.state.height / 100).toFixed(2);
            ctx.font = fontSize + "em sans-serif";
            ctx.textBaseline = "middle";
            ctx.fillStyle = 'black';

            let textX = Math.round((center_x - ctx.measureText(text1).width) / 2),
                textY = (center_y - (hText/2));
            ctx.fillText(text1, textX, textY);

            textX = Math.round((center_x - ctx.measureText(text2).width) / 2);
            textY = (center_y + (hText));
            ctx.fillText(text2, textX, textY);
            ctx.restore();
        }



    }

    render() {

        let tagHeight = this.state.height + "px";

        return (
        <div className="ui segments">
            <div className="ui secondary segment">
                <p>Riepilogo Orario del <LocalDate data={this.props.giorno}/></p>
            </div>
            <div  className="ui segment">
                <div ref="chartContainer">
                <canvas ref="chart" style={{width:"100%", height:{tagHeight}}} width={this.state.width} height={this.state.height}>
                    <h3>{this.props.message}</h3>
                </canvas>
                </div>
            </div>
        </div>
        )
    }
}

AttivitaRiepilogoOrarioCircolare.PropTypes = {
    giorno: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    idUtente: PropTypes.number.isRequired,
    maxSovrapposizioni: PropTypes.number.isRequired,
    attivitaCorrente: PropTypes.object.isRequired,
    attivitaComplete: PropTypes.array.isRequired,
    onChartUpdated: PropTypes.func,
}

AttivitaRiepilogoOrarioCircolare.defaultProps = {
    maxSovrapposizioni: 10,
}

export default AttivitaRiepilogoOrarioCircolare;




/** WEBPACK FOOTER **
 ** ./src/components/attivita/AttivitaRiepilogoOrarioCircolare.js
 **/